import axios from 'axios';

import cfac22 from '../cfac22';

export default function deleteFavorite(uId, id, type) {
  return new Promise((resolve, reject) => {
    Promise.resolve().
    then(() => {
      axios.
      delete(`${cfac22('API_HOST_V2')}/users/favorites`, {
        headers: { 'Full-Url': window.location.href },
        data: {
          payload: { id: id, type: type }
        }, withCredentials: true
      }).
      then((result) => {
        // console.log("RESULT_DELETE_FAVORITES: ", result);
        resolve(result.data);
      }).
      catch((error) => {
        //console.log("ERROR_DELETE_FAVORITES: ", error);
        return reject(error);
      });
    }).
    catch((error) => {
      //console.log("ERROR_TOKEN:", error);
      reject(error);
    });
  });
}
